import Header from "./Header";
import Footer from "./Footer";

function Payment() {
  return (
    <>
      <Header />

      <section class="my-6">
        <div class="container">
          <span className="text-uppercase text-secondary fw-semibold ls-sm">
            Payment & Refund Policy
          </span>
          <h2 className="h1 fw-semibold ls-sm text-success lh-1">
            SLN Academy's Payment Policy
          </h2>
          <div className="mt-n3 pt-2">
            <img src="/assets/images/line-shap.webp" width="230" className="mt-2" />
          </div>

          <div className="mt-3 lh-md">
            <h4 className="m-0 lh-sm">1. Course Fees</h4>
            <p>
              All course fees displayed on the SLN Academy website are inclusive
              of applicable taxes unless stated otherwise.
            </p>

            <h4 className="m-0 lh-sm">2. Mode of Payment</h4>
            <p>Payments can be made through:</p>
            <ul>
              <li>UPI</li>
              <li>Debit / Credit Cards</li>
              <li>Net Banking</li>
              <li>
                Other secure online payment gateways integrated on the website
              </li>
            </ul>
            <p>
              All payments are processed through secure and encrypted payment
              systems.
            </p>

            <h4 className="m-0 lh-sm">3. Confirmation of Payment</h4>
            <p>Upon successful payment:</p>
            <ul>
              <li>Users will receive a confirmation via email / WhatsApp</li>
              <li>
                Course access details will be shared as per the course schedule
              </li>
            </ul>

            <h4 className="m-0 lh-sm">4. Refund Policy</h4>
            <ul>
              <li>
                Course fees once paid are non-refundable, unless explicitly
                mentioned under a specific course.
              </li>
              <li>
                Any refund (if applicable) will be processed as per the
                course-specific refund terms mentioned on the website.
              </li>
            </ul>

            <h4 className="m-0 lh-sm">5. Failed / Duplicate Transactions</h4>
            <p>In case of:</p>
            <ul>
              <li>Failed payment</li>
              <li>Duplicate debit</li>
            </ul>
            <p>
              Users are requested to contact our support team with transaction
              details. Refunds (if applicable) will be processed within 7–10
              working days.
            </p>

            <h4 className="m-0 lh-sm">6. Right to Modify</h4>
            <p>
              SLN Academy reserves the right to modify pricing, payment terms,
              or refund policies at any time without prior notice.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Payment;
